import React from 'react';

export const Graphics = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.00039 0.900024C6.85214 0.900024 4.79187 1.75341 3.27283 3.27246C1.75378 4.7915 0.900391 6.85177 0.900391 9.00002C0.900391 11.1483 1.75378 13.2085 3.27283 14.7276C4.79187 16.2466 6.85214 17.1 9.00039 17.1C11.1486 17.1 13.2089 16.2466 14.728 14.7276C16.247 13.2085 17.1004 11.1483 17.1004 9.00002C17.1004 6.85177 16.247 4.7915 14.728 3.27246C13.2089 1.75341 11.1486 0.900024 9.00039 0.900024ZM8.10039 2.76462C6.76228 2.95774 5.51288 3.57799 4.54562 4.54525C3.36414 5.72673 2.70039 7.32916 2.70039 9.00002C2.70039 10.6709 3.36414 12.2733 4.54562 13.4548C5.7271 14.6363 7.32953 15.3 9.00039 15.3C10.3683 15.3 11.6904 14.8551 12.7731 14.0455L8.36399 9.63642C8.19521 9.46764 8.10039 9.23872 8.10039 9.00002V2.76462ZM14.0459 12.7727L9.90039 8.62723V2.76462C11.2385 2.95774 12.4879 3.57799 13.4552 4.54525C14.6366 5.72673 15.3004 7.32916 15.3004 9.00002C15.3004 10.3679 14.8555 11.69 14.0459 12.7727Z"
				fill="#64778F"
			/>
		</svg>
	);
};
